import React from 'react';
import logoFull from '@/assets/advoq-logo-full.png';
import logoMark from '@/assets/advoq-logo-mark.png';

export default function BrandLogo({ variant = 'full', alt = 'Advoq', className = '', ...props }) {
  const src = variant === 'mark' ? logoMark : logoFull;

  return <img src={src} alt={alt} className={className} draggable="false" {...props} />;
}
